import {
  dataFlow,
  envInfo,
  ClueTracker,
  webpackEnv,
  number,
} from '@ali/alipic-utils';
import { mtopFetch } from "./mtopFetch";

import {
  getToken,
} from './auth';
import {
  flattenRoute
} from './router';
import validator from './validator';
import Tracker from '@ali/tracker';
import InterfacePlugin from '@ali/tracker/plugins/Interface';
import PerformancePlugin from '@ali/tracker/plugins/Performance';
import { message } from 'antd';

// config
import CONFIG from '../config';

// 环境判断
const env = envInfo({
  dev() {
    return window.location.host.indexOf(':') > -1 || window.localStorage.env === 'dev';
  },
  daily() {
    return window.localStorage.env === 'daily' || CONFIG.DAILY === window.location.host;
  },
  pre() {
    return CONFIG.PRE === window.location.host;
  },
  prod() {
    return CONFIG.PROD === window.location.host
  },
});

// 配置MTOP（包含业务前缀）
const m = mtopFetch({
  env,
  prefix: CONFIG.MTOP_PREFIX,
});

const mtop = m.request;

// 配置MTOP（通用MTOP，任意前缀）
const m2 = mtopFetch({
  env,
});

const mtopAnon = m2.request;

const mtopInjection = (success, failure) => {
  m.inject({
    success,
    failure,
    token: getToken.bind(this, CONFIG.APP_ID),
    tb_eagleeyex_scm_project: JSON.parse(window.sessionStorage.getItem(CONFIG.APP_ID)).tb_eagleeyex_scm_project
  });
  m2.inject({
    success,
    failure,
    token: getToken.bind(this, CONFIG.APP_ID),
    tb_eagleeyex_scm_project: JSON.parse(window.sessionStorage.getItem(CONFIG.APP_ID)).tb_eagleeyex_scm_project
  });
};

// 配置CLUE
// const clueTracker = new ClueTracker({
//   pid: CONFIG.CLUE_PID,
// });
const tracker = new Tracker({
  pid: CONFIG.CLUE_PID,
  plugins: [
    [InterfacePlugin],// 接口
    [PerformancePlugin], // 性能
  ],
});



const webpack = webpackEnv(env);


/**
 * 根据nextProps等进行异步请求处理
 * @param {Object} thisProp           [当前状态]
 * @param {Object} nextProp           [下一个状态]
 * @param {Function} callback         [请求返回正常的处理逻辑]
 * @param {Function} errorHandler     [请求返回出错的处理逻辑]
 * @param {Function} defaultCallback  [其他情况的处理逻辑]
 */
const judgeNextProps = (thisProp, nextProp, callback, errorHandler = () => {}, defaultCallback = () => {}) => {
  if (isFetching(thisProp, nextProp)) {
    if (nextProp.error) {
      errorHandler(nextProp.error);
    } else {
      callback();
    }
    return true;
  } else {
    defaultCallback();
    return false;
  }
};

function isFetching(thisProp, nextProp) {
  return thisProp.isFetching && !nextProp.isFetching;
}

// message 统一设置，一个页面最多显示1个
message.config({
  maxCount: 1,
});

export {
  dataFlow,
  mtop,
  mtopAnon,
  env,
  // clueTracker,
  tracker,
  webpack,
  flattenRoute,
  mtopInjection,
  number,
  validator,
  judgeNextProps,
  isFetching
};



// WEBPACK FOOTER //
// ./src/utils/index.js